import { Component, NgZone, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { randomId } from 'server/shared/helpers/random';
import { Toast } from 'server/shared/models/toast';
import { ToastService } from './toast.service';

@Component({
  selector: 'toast',
  templateUrl: 'toast.component.html',
  styleUrls: ['toast.component.scss'],
})
export class ToastComponent implements OnDestroy {
  toasts: Toast[];
  toasts$ = new BehaviorSubject<Toast[]>([]);
  private toastSubscription?: Subscription;

  constructor(private toastService: ToastService, private ngZone: NgZone) {
    this.toastSubscription = this.toastSubscription
      ? this.toastSubscription
      : this.toastService.toastAdded$.subscribe((toast) =>
          this.onToastAdded(toast),
        );
    this.toasts = [];
    this.toasts$.next(this.toasts);
  }

  private onToastAdded(toast: Toast): void {
    toast.id = randomId();
    toast.timeout = toast.timeout ? toast.timeout : 4000;
    this.ngZone.run(() => {
      this.toasts.push(toast);
      this.toasts$.next(this.toasts);
    });
    setTimeout(() => {
      this.dismiss(toast);
    }, toast.timeout);
  }

  dismiss(toast: Toast) {
    let index = this.toasts.findIndex((toast1) => toast1.id == toast.id);
    const toastElement = document.getElementById('snackbar-' + toast.id);
    if (index > -1 && toastElement) {
      //Todo: create component for toast-item
      toastElement.classList.remove('fadein');
      toastElement.className += ' fadeout';
      setTimeout(() => {
        this.ngZone.run(() => {
          // needs to use findIndex again since it might have changed during timeout
          this.toasts.splice(
            this.toasts.findIndex((toast1) => toast1.id == toast.id),
            1,
          );
        });
        this.toasts$.next(this.toasts);
      }, 300);
    }
  }

  setTimeoutAnimation(toast: Toast) {
    return {
      animation: 'timeout ' + (toast.timeout || 0) / 1000 + 's linear',
    };
  }

  ngOnDestroy() {
    if (this.toastSubscription) {
      this.toastSubscription.unsubscribe();
      delete this.toastSubscription;
    }
  }
}
